import { Card } from 'antd';

function CommiteeOpinionArea({ ownerCommitteeOpinion }) {
  return (
    <Card className={`${ownerCommitteeOpinion ? 'gx-display-block' : 'gx-display-none'}`}>
      <h3>Sorumlu Heyet Görüşü</h3>
      <p>{ownerCommitteeOpinion}</p>
    </Card>
  );
}
export default CommiteeOpinionArea;
